import React from 'react';

import { Grid } from '@mui/material';
import { EditorRightToolbar } from 'src/editor/toolbars/right-panel/EditorRightToolbar';
import { useEditorViewPreferences } from 'src/editor/vars';
import { WordProcessor } from 'src/editor/WordProcessor';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  subGrid: {
    backgroundColor: theme.appColors.defaultFieldBackground,
    flexGrow: 1,
    overflow: 'hidden',
    position: 'relative' as const,
  },
}));

export function EditorBody(): JSX.Element {
  const { classes } = useStyles();
  const { fullScreen } = useEditorViewPreferences();

  return (
    <Grid container className={classes.subGrid} wrap="nowrap">
      <WordProcessor />
      {!fullScreen && <EditorRightToolbar />}
    </Grid>
  );
}
